import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Tours from "./pages/Tours";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import AboutUs from "./pages/AboutUs";
import Kidepo from "./components/tours/tour-places/tour-1/Kidepo";
import Mburo from "./components/tours/tour-places/tour-2/Mburo";
import Elgon from "./components/tours/tour-places/tour-4/Elgon";
import Machison from "./components/tours/tour-places/tour-5/Machison";
import Elizabeth from "./components/tours/tour-places/tour-6/Elizabeth";
import Mahinga from "./components/tours/tour-places/tour-7/Mahinga";


const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <Navbar/>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/tours" element={<Tours />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/kidepo" element={<Kidepo />} />
        <Route path="/mburo" element={<Mburo />} />
        <Route path="/elgon" element={<Elgon />} />
        <Route path="/machison" element={<Machison />} />
        <Route path="/elizabeth" element={<Elizabeth />} />
        <Route path="/mahinga" element={<Mahinga />} />
        
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App; 
